const selectors = {
  newsletterForm: '[data-newsletter-form]',
};

const classes = {
  success: 'has-success',
  error: 'has-error',
};

const sections = {};

class NewsletterCheckForResult {
  constructor(newsletter) {
    this.sessionStorage = window.sessionStorage;
    this.newsletter = newsletter;

    this.stopSubmit = true;
    this.isChallengePage = false;
    this.formID = null;

    this.checkForChallengePage();

    this.newsletterSubmit = (e) => this.newsletterSubmitEvent(e);

    if (!this.isChallengePage) {
      this.init();
    }
  }

  init() {
    this.newsletter.addEventListener('submit', this.newsletterSubmit);

    this.showMessage();
  }

  newsletterSubmitEvent(e) {
    if (this.stopSubmit) {
      e.preventDefault();

      this.removeStorage();
      this.writeStorage();
      this.stopSubmit = false;
      this.newsletter.submit();
    }
  }

  checkForChallengePage() {
    this.isChallengePage = window.location.pathname === '/challenge';
  }

  writeStorage() {
    if (this.sessionStorage !== undefined) {
      this.sessionStorage.setItem('newsletter_form_id', this.newsletter.id);
    }
  }

  readStorage() {
    this.formID = this.sessionStorage.getItem('newsletter_form_id');
  }

  removeStorage() {
    this.sessionStorage.removeItem('newsletter_form_id');
  }

  showMessage() {
    this.readStorage();

    if (this.newsletter.id === this.formID) {
      const newsletter = document.getElementById(this.formID);

      if (window.location.search.indexOf('?customer_posted=true') !== -1) {
        newsletter.classList.remove(classes.error);
        newsletter.classList.add(classes.success);
      } else if (window.location.search.indexOf('accepts_marketing') !== -1) {
        newsletter.classList.remove(classes.success);
        newsletter.classList.add(classes.error);
      }

      this.scrollToForm(newsletter);
    }
  }

  scrollToForm(newsletter) {
    const rect = newsletter.getBoundingClientRect();
    const isVisible =
      rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && rect.right <= (window.innerWidth || document.documentElement.clientWidth);

    if (!isVisible) {
      setTimeout(() => {
        window.scroll({
          top: rect.top,
          left: 0,
          behavior: 'smooth',
        });
      }, 400);
    }
  }

  unload() {
    this.newsletter.removeEventListener('submit', this.newsletterSubmit);
  }
}

const newsletterCheckForResultSection = {
  onLoad() {
    sections[this.id] = [];
    const newsletters = this.container.querySelectorAll(selectors.newsletterForm);
    newsletters.forEach((form) => {
      sections[this.id].push(new NewsletterCheckForResult(form));
    });
  },
  onUnload() {
    sections[this.id].forEach((form) => {
      if (typeof form.unload === 'function') {
        form.unload();
      }
    });
  },
};

export {newsletterCheckForResultSection};
